import { Outlet, Link } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div className="auth-layout min-vh-100 d-flex">
      <div className="auth-sidebar d-none d-lg-flex flex-column justify-content-between p-5 text-white" 
           style={{ 
             width: '45%', 
             background: 'linear-gradient(135deg, #0066e6 0%, #ff6b45 100%)',
             position: 'relative',
             overflow: 'hidden'
           }}>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <Link to="/" className="navbar-brand text-white fs-3 fw-bold mb-5 d-inline-block">
            Job<span style={{ color: '#ffd54d' }}>Hive</span>
          </Link>
          <h1 className="display-5 fw-bold mb-4">Find Your Dream Job or Hire Top Talent</h1>
          <p className="fs-5 opacity-75">
            Join thousands of job seekers and employers who trust JobHive for their career and hiring needs.
          </p>
        </div>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div className="d-flex gap-5 mb-4">
            <div>
              <h3 className="fw-bold mb-0">500K+</h3>
              <small className="opacity-75">Active Jobs</small>
            </div>
            <div>
              <h3 className="fw-bold mb-0">100K+</h3>
              <small className="opacity-75">Companies</small>
            </div>
            <div>
              <h3 className="fw-bold mb-0">2M+</h3>
              <small className="opacity-75">Job Seekers</small>
            </div>
          </div>
        </div>
        <div style={{ position: 'absolute', bottom: '-50%', right: '-20%', width: '80%', height: '100%', background: 'rgba(255,255,255,0.1)', borderRadius: '50%' }}></div>
      </div>

      <div className="auth-content flex-grow-1 d-flex align-items-center justify-content-center p-4" style={{ background: '#f8fafc' }}>
        <div className="w-100" style={{ maxWidth: '440px' }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
